import React, { lazy, Suspense, createContext, useContext, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Toastify from "./components/Common/Toastify";
import SpinnerOne from "./components/Common/Spinner";
import Sidebar from "./components/Common/Sidebar";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import 'nprogress/nprogress.css'

const SidebarContext = createContext();
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
export const SidebarProvider = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleSidebar = () => setIsExpanded((prev) => !prev);
  const expandSidebar = () => setIsExpanded(true);
  const collapseSidebar = () => setIsExpanded(false);
  return (
    <SidebarContext.Provider value={{ isExpanded, toggleSidebar, expandSidebar, collapseSidebar, }} >
      {children}
    </SidebarContext.Provider>);
};
// Lazy components 
const Dashboard = lazy(() => import("./components/Common/Dashboard"));
const ChangePassword = lazy(() => import("./components/Common/profile/ChangePassword.jsx"));
const LandingPage = lazy(() => import("./components/login/LandingPage"));
const Admin = lazy(() => import("./components/admin/Admin"));
const NewPassword = lazy(() => import("./components/login/NewPassword"));
const ForgotPage = lazy(() => import("./components/login/ForgotPage"));
const RestorePassword = lazy(() => import("./components/login/RestorePassword"));
const DsrRecords = lazy(() => import("./components/dailyStatusReport/dsrRecords"));

function AppLayout() {
  const location = useLocation();
  const { isExpanded } = useSidebar();
  const hideSidebarRoutes = ["/", "/setup-account", "/forgotpassword", "/restore-password"];
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);
  return (
    <div className="App">
      {shouldHideSidebar ? (
        <>
          <Suspense fallback={<SpinnerOne />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/setup-account" element={<NewPassword />} />
              <Route path="/forgotpassword" element={<ForgotPage />} />
              <Route path="/restore-password" element={<RestorePassword />} />
            </Routes>
          </Suspense>
        </>
      ) : (
        <div className="main-layout">
          <Sidebar />
          <div className={`side-content-app ${isExpanded ? "content-expanded" : "content-collapsed"}`}>
            {/* <TopNav /> */}
            <Suspense fallback={<SpinnerOne />}>
              <Routes> <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/dsr" element={<DsrRecords />} />
                <Route path="/profile/change-password" element={<ChangePassword />} />
              </Routes> </Suspense> </div> </div>)
      } </div >);
}
function App() {
  return (
    <Provider store={store}>
      <Toastify />
      <SidebarProvider>
        <AppLayout />
      </SidebarProvider>
    </Provider>
  );
}
export default App;
